import React, { useCallback, useEffect, useState } from 'react';
import Loading from '../../../components/loading/Loading';
import useStyles from './styles';
import {
    PAYMENT_STANCER_URL,
    STANCER_PAYMENT_STATUS,
} from '../../../components/myeirconstant/myEirConstant';
import { getOneOffPaymentIframe, validateOneOffpayment } from './stancer.util';
import { Box, Checkbox, Typography } from '@material-ui/core';
import { useApolloClient } from '@apollo/client';
import CustomUpdatedPopUpModal from '../../eir-porting/CustomModal/CustomUpdatedPopUpModal';
import errorIcon from '../../../mobilecomponents/images/warning.png';

const {
    FINISHED,
    ERROR,
    PENDING,
    SECURE_AUTH_END,
    SECURE_AUTH_ERROR,
    SECURE_AUTH_START,
    INIT,
    INVALID,
} = STANCER_PAYMENT_STATUS;
/**
 * @name StancerOneOffPaymentContainer - jsx component for Stancer payment flow
 * @param {object} props - Object containing react props
 * @returns {JSX.Element} - Renders StancerOneOffPaymentContainer component
 */
const StancerOneOffPaymentContainer = props => {
    const { payableAmount, handleNext, setStatus, setHeader, setPaidAmount } = props;
    const graphql = useApolloClient();
    const classes = useStyles();
    const [loading, setLoading] = useState(true);
    const [hpp, setHpp] = useState(null);
    const [checked, setChecked] = useState(false);
    const [openErrorPopup, setOpenErrorPopup] = useState(false);
    const [paymentErrorPopup, setPaymentErrorPopup] = useState(false);

    // checkbox action
    const handleCheckBox = () => {
        setChecked(!checked);
    };

    /**
     * @function handleToggleErrorPopup
     * @description Function toggle stancer status error
     */
    const handleToggleErrorPopup = () => {
        setOpenErrorPopup(!openErrorPopup);
    };

    /**
     * @function onLoadGetOneOffPaymentIFrame
     * @description Function to load one off payment iframe
     */
    const onLoadGetOneOffPaymentIFrame = () => {
        getOneOffPaymentIframe({ graphql, setHpp, setLoading, payableAmount, setOpenErrorPopup });
        setOpenErrorPopup(false);
    };

    useEffect(() => {
        onLoadGetOneOffPaymentIFrame();
    }, []);

    /**
     * @function submitPayment
     * @description Function for submitting add card payemnt using message event handler
     */
    const submitPayment = useCallback(
        event => {
            if (event.origin !== PAYMENT_STANCER_URL) {
                return;
            }
            if (event?.data?.status === PENDING) {
                return;
            }
            if (event?.data?.status === SECURE_AUTH_END) {
                return;
            }
            if (event?.data?.status === SECURE_AUTH_ERROR) {
                return;
            }
            if (event?.data?.status === SECURE_AUTH_START) {
                return;
            }
            if (event?.data?.status === INIT) {
                return;
            }
            if (event?.data?.status === ERROR || event?.data?.status === INVALID) {
                setOpenErrorPopup(true);
            }
            if (event?.data?.status === FINISHED) {
                const paymentId = hpp?.paymentIntentId;
                if (paymentId)
                    validateOneOffpayment({
                        graphql,
                        paymentId,
                        payableAmount,
                        setStatus,
                        setPaidAmount,
                        handleNext,
                        checked,
                        setPaymentErrorPopup,
                        setOpenErrorPopup,
                    });
            }
        },
        [hpp?.paymentIntentId, graphql, checked]
    );

    useEffect(() => {
        window.addEventListener('message', submitPayment, false);
        return () => window.removeEventListener('message', submitPayment);
    }, [submitPayment]);

    useEffect(() => {
        setHeader('Payment summary');
    }, []);

    return (
        <React.Fragment>
            <Box className={classes.PaymentIframeModal}>
                {loading && <Loading />}
                {!loading && hpp && (
                    <>
                        <iframe
                            id='target-iframe'
                            title='stancer-selfcare-one-off-iframe'
                            frameBorder='0'
                            src={hpp?.url}
                            height={window?.innerWidth <= 768 ? '700px' : '820px'}
                            width={'100%'}
                        />
                        <Box className={classes.checkBox}>
                            <Checkbox checked={checked} onClick={handleCheckBox} />
                            <Typography variant='body1' className={classes.checkBoxText}>
                                Save my payment method for future use
                            </Typography>
                        </Box>
                    </>
                )}
            </Box>
            {openErrorPopup && (
                <Box id='my-eir-pop-up'>
                    <CustomUpdatedPopUpModal
                        open={openErrorPopup}
                        toggle={handleToggleErrorPopup}
                        cta1={{
                            text: paymentErrorPopup ? 'Close' : 'Try again',
                            action: () => {
                                paymentErrorPopup
                                    ? setOpenErrorPopup(false)
                                    : onLoadGetOneOffPaymentIFrame();
                            },
                            disable: false,
                        }}
                        cta2={{ text: '', action: () => {} }}
                    >
                        <Box className={classes.successPopup}>
                            <Box className={classes.successImg}>
                                <Typography component='img' src={errorIcon} alt='failure' />
                            </Box>

                            <Typography className={classes.imgTextAdditional}>
                                {paymentErrorPopup
                                    ? 'Something went wrong on our end, please wait 24 hours to see if the payment reflects on your account. If not, please try again.'
                                    : 'Sorry something went wrong! Please try again'}
                            </Typography>
                        </Box>
                    </CustomUpdatedPopUpModal>
                </Box>
            )}
        </React.Fragment>
    );
};

export default StancerOneOffPaymentContainer;
